import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { VehicleTableManager } from '../Vehicle/Table/VehicleTableManager';
import { DriverTableManager } from '../Driver/Table/DriverTableManager';

export type FleetTab = 'vehicles' | 'drivers';

export interface FleetPageProps {
  activeTab?: FleetTab;
  onTabChange?: (tab: FleetTab) => void;
  defaultTab?: FleetTab;
}

export function FleetPage({ activeTab: controlledTab, onTabChange, defaultTab = 'vehicles' }: FleetPageProps) {
  const { t } = useTranslation(['m-fleet', 'm-vehicle', 'm-driver']);
  const [internalTab, setInternalTab] = useState(defaultTab);

  const activeTab = controlledTab ?? internalTab;
  const setActiveTab = onTabChange ?? setInternalTab;

  const tabs = [
    { id: 'vehicles' as const, label: t('tabs.vehicles') },
    { id: 'drivers' as const, label: t('tabs.drivers') },
  ];

  const activeTabContent =
    activeTab === 'vehicles' ? (
      <VehicleTableManager />
    ) : (
      <DriverTableManager />
    );

  return (
    <>
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <div className="flex border-b border-gray-200">
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  relative px-6 py-3 text-sm font-medium transition-colors
                  ${
                    activeTab === tab.id
                      ? 'text-primary border-b-2 border-primary'
                      : 'text-gray-500 hover:text-gray-700'
                  }
                `}>
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-2">{activeTabContent}</div>
      </div>
    </>
  );
}
